import { FC, ReactNode, useMemo } from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames/bind';
import Button from '../common/button';

interface IProps {
    isActive: boolean;
    children: ReactNode;
    onClick: () => void;
}

const cx = classNames.bind(styles);
const TableTag: FC<IProps> = ({ children, isActive, onClick }) => {
    const rootStyles = useMemo(() => cx([styles.root]), []);

    return (
        <Button
            size="small"
            variant={!isActive ? 'chip' : 'active-chip'}
            className={rootStyles}
            onClick={onClick}>
            {children}
        </Button>
    );
};

export default TableTag;
